import React from "react";
import { useState, useEffect } from "react";
import axios from "axios";
import SideBar from "../../SideBar";
import { useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";
import { ButtonComponent } from "@syncfusion/ej2-react-buttons";
import { SidebarComponent } from "@syncfusion/ej2-react-navigations";

import {
    FaCashRegister,
    FaFileMedical,
    FaRegEdit,
    FaRegTrashAlt,
} from "react-icons/fa";

import HeaderName from "../../HeaderName";
import { useSelector } from "react-redux";
import SimpleExcelImportDialog from "../../../features/simpleExcelImportDialog";

function UnitConvention() {
    const token = localStorage.getItem("token");
    const url = process.env.REACT_APP_APP_URL;
    const api = axios.create({
        baseURL: url,
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        },
    });
    const [unitConventionLists, setUnitConventionLists] = useState([]);
    const [itemLists, setItemLists] = useState([]);
    const [item, setItem] = useState("")
    const [code, setCode] = useState("");
    const [name, setName] = useState("");
    const [fromUnit, setFromUnit] = useState(0)
    const [toUnit, setToUnit] = useState(0)
    const [description, setDescription] = useState("");
    const [showUpdate, setShowUpdate] = useState(false);
    const [itemID, setItemID] = useState("");
    const [medicineLists, setMedicineLists] = useState([]);
    const [fromUnitName, setFromUnitName] = useState("");
    const [toUnitName, setToUnitName] = useState("");
    const [unitList, setUnitList] = useState([]);
    const [unitData, setUnitData] = useState("");
    const [Id, setId] = useState("");
    const [openImport, setOpenImport] = useState(false);
    const showImportDialog = () => setOpenImport(true);

    const handleDelete = (event) => {
        api
            .delete("unit-convention/" + event)
            .then((response) => {
                Swal.fire({
                    title: "Success",
                    text: "Successfully Deleted!",
                    icon: "success",
                    showConfirmButton: false,
                    timer: 2000
                });
                const result = unitConventionLists.filter((item) => item._id !== event);
                setUnitConventionLists(result);
            })
            .catch((error) => {
                Swal.fire({
                    title: "Error",
                    text: error.response.data.message,
                    icon: "error",
                    showConfirmButton: false,
                    timer: 2000
                });
            });
    };

    const handleUpdate = (event) => {
        // console.log(event, "event");
        const getCatUpdate = async () => {
            try {
                const res = await api.get("unit-convention/" + event);
                // console.log(res.data.data, 'uni');
                setUnitData(res.data.data)
                setFromUnit(res.data.data?.fromUnit)
                setToUnit(res.data.data?.toUnit)
                setDescription(res.data.data?.description)

            } catch (err) { }
        };
        getCatUpdate();
        setShowUpdate(true);
        setId(event);
    };

    const UnitUpdate = () => {
        const data = {
            relatedItem: item ? item : unitData.relatedItem?._id,
            fromUnit: fromUnit || 1,
            toUnit: toUnit || 1,
            description: description,
            relatedFromUnit: fromUnitName || unitData?.relatedFromUnit?._id,
            relatedToUnit: toUnitName || unitData?.relatedToUnit?._id
        };

        const config = {
            headers: { "Content-Type": "application/json" },
        };
        api
            .put("unit-convention/" + Id, data, config)
            .then(function (response) {
                Swal.fire({
                    title: "Successful!",
                    text: "You Updated Data!",
                    icon: "success",
                    showConfirmButton: false,
                    timer: 2000
                });
                window.location.reload()
            })
            .catch(function (err) {
                Swal.fire({
                    title: "Something Wrong!",
                    text: "Try again, Please.",
                    icon: "warning",
                    showConfirmButton: false,
                    timer: 2000
                });
            });

    };

    const UnitCreate = () => {
        const data = {
            relatedItem: item,
            fromUnit: fromUnit || 1,
            toUnit: toUnit || 1,
            description: description,
            relatedFromUnit: fromUnitName,
            relatedToUnit: toUnitName
        };

        const config = {
            headers: { "Content-Type": "application/json" },
        };
        api
            .post("unit-convention", data, config)
            .then(function (response) {
                Swal.fire({
                    title: "Successful!",
                    text: "You Created Data!",
                    icon: "success",
                    showConfirmButton: false,
                    timer: 2000
                });

                window.location.reload();
            })
            .catch(function (err) {
                alert(err.message);
            });

    };


    useEffect(() => {

        const getUnitLists = async () => {
            try {
                const res = await api.get("unit-convention");

                // setUnitLists(res.data.list.filter((el)=>el.name._id == medicineListId))

                setUnitConventionLists(res.data.data);
                // console.log(res.data.list);
            } catch (err) { }
        };
        const getMedicineLists = async () => {
            try {
                const res = await api.get("medicine-lists");

                setMedicineLists(res.data.list);
            } catch (err) {
                alert(err.message);
            }
        };

        getMedicineLists();
        getUnitLists()

    }, []);
    const getItemLists = async (id) => {
        try {
            const res = await api.get("medicine-items");

            // setUnitLists(res.data.list.filter((el)=>el.name._id == medicineListId))

            setItemLists(res.data.list.filter(el => el.name._id === id));
            // console.log(res.data.list, 'i');
        } catch (err) { }
    };
    const handleItems = (id) => {
        setItemID(id)
        getItemLists(id)
    }
    let sidebarObj;
    function onCreate() {
        sidebarObj.element.style.visibility = "";
    }
    function open() {
        console.log("Sidebar is opened");
    }
    function close() {
        console.log("Sidebar is closed");
    }

    // Toggle(Open/Close) the Sidebar
    function toggleClick() {
        sidebarObj.toggle();
    }
    const handleUnit = (id) => {
        setItem(id)
        const res = itemLists.filter(el => el._id === id)[0]
        // console.log(res, 'res')
        setUnitList(res?.relatedItemUnits)
    }
    return (
        <div classNameName='App'>
            {/* <!-- end preloader --> */}
            {/* @include('sweet::alert') */}

            <div className='wrapper'>
                {/* <!-- Navbar --> */}
                <HeaderName />

                {/* <!-- /.navbar --> */}

                {/* <!-- Main Sidebar Container --> */}
                <SideBar />

                {/* <!-- Content Wrapper. Contains page content --> */}

                <div className='content-wrapper'>
                    {/* <!-- Content Header (Page header) --> */}
                    <div className='content-header'>
                        <div className='container-fluid'>
                            <div className='row mb-2'>
                                <div className='col-sm-9'>
                                    <ol className='breadcrumb'>
                                        <li className='breadcrumb-item active'>UnitConvention List</li>
                                    </ol>
                                </div>
                                <div className='col-2 mt-1'>
                                    <button
                                        type='button'
                                        className='btn  btn-primary'
                                        style={{ borderRadius: "7px" }}
                                        onClick={showImportDialog}
                                    >
                                        Import
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <!-- Main content --> */}

                    <section className='content'>
                        <div className='container-fluid'>
                            <div className='row'>
                                <div className='col-9'>
                                    <div className='card'>
                                        <div className='card-header'>
                                            {/* <h3 className="card-title">Cost Center List</h3> */}
                                        </div>
                                        <div className='card-body'>
                                            <table id='example1' className='table'>
                                                <thead className='text-center ok'>
                                                    <tr>
                                                        <th>No</th>
                                                        <th>Product</th>
                                                        <th>Items</th>
                                                        <th>From Unit Name</th>
                                                        <th>To Unit Name</th>
                                                        <th>From Unit Qty</th>
                                                        <th>To Unit Qty</th>

                                                        <th>Description</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>

                                                {unitConventionLists[0] && unitConventionLists.map((cat, i) => (
                                                    <tbody className='text-center'>
                                                        <tr>
                                                            <td>{++i}</td>
                                                            <td>{cat.relatedItem?.name?.name}</td>
                                                            <td>{cat.relatedItem?.medicineItemName}</td>

                                                            <td>{cat?.relatedFromUnit?.unitName}</td>
                                                            <td>{cat?.relatedToUnit?.unitName}</td>
                                                            <td>{cat.fromUnit}</td>
                                                            <td>{cat.toUnit}</td>
                                                            <td>{cat.description}</td>
                                                            <td className='text-center'>
                                                                <button
                                                                    className='btn btn-sm btn-warning'
                                                                    onClick={(e) => handleUpdate(cat._id)}
                                                                >
                                                                    <FaRegEdit />
                                                                </button>
                                                                &nbsp; &nbsp;
                                                                <button
                                                                    className='btn btn-sm btn-danger'
                                                                    onClick={(e) => handleDelete(cat._id)}
                                                                >
                                                                    <FaRegTrashAlt />
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                ))}
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                {showUpdate ? (
                                    <div className='col-md-3'>
                                        <div className='card px-3 py-3'>
                                            <h5 className='card-header mb-4 fw-5 text-secondary'>
                                                Update UnitConvention
                                            </h5>
                                            <div class='form-group'>
                                                <label for='code' className='text-secondary'>
                                                    Products
                                                </label>
                                                <select
                                                    class='custom-select border-info'
                                                    name='account_type_id'
                                                    id='cat'
                                                    onChange={(e) => handleItems(e.target.value)}
                                                >
                                                    <option>Choose Category</option>
                                                    {medicineLists[0] && medicineLists.map((option) => (
                                                        <option value={option._id}>{option.name}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div class='form-group'>
                                                <label for='code' className='text-secondary'>
                                                    Items
                                                </label>
                                                <select
                                                    class='custom-select border-info'
                                                    name='account_type_id'
                                                    id='cat'
                                                    onChange={(e) => handleUnit(e.target.value)}
                                                >
                                                    <option hidden>{unitData.relatedItem ? unitData.relatedItem?.medicineItemName : "Choose Category"}</option>
                                                    {itemLists[0] && itemLists.map((option) => (
                                                        <option value={option._id}>{option.medicineItemName}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className='border border-black p-2 rounded-lg'>
                                                <div className='py-2'>
                                                    <span className='text-lg font-weight-bold'>Unit Convention</span>
                                                </div>
                                                <div className='row '>
                                                    <div class='form-group col-6'>
                                                        <label for='name' className='text-secondary'>
                                                            From Unit Name
                                                        </label>
                                                        <select
                                                            class='custom-select border-info'
                                                            name='account_type_id'
                                                            id='cat'

                                                            onChange={(e) => setFromUnitName(e.target.value || unitData?.relatedFromUnit?._id)}
                                                        >
                                                            <option hidden>{unitData?.relatedFromUnit?.unitName || "Choose"}</option>
                                                            {(unitData._id ? unitData?.relatedItem?.relatedItemUnits : unitList)?.map((option) => (
                                                                <option value={option._id}>{option.unitName}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div class='form-group col-6'>
                                                        <label for='name' className='text-secondary'>
                                                            To Unit Name
                                                        </label>
                                                        <select
                                                            class='custom-select border-info'
                                                            name='account_type_id'
                                                            id='cat'
                                                            onChange={(e) => setToUnitName(e.target.value || unitData?.relatedToUnit?._id)}
                                                        >
                                                            <option hidden>{unitData?.relatedToUnit?.unitName || "Choose"}</option>
                                                            {(unitData._id ? unitData?.relatedItem?.relatedItemUnits : unitList).map((option) => (
                                                                <option value={option._id}>{option.unitName}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div class='form-group col-6'>
                                                        <label for='name' className='text-secondary'>
                                                            From Qty
                                                        </label>
                                                        <input
                                                            type='number'
                                                            class='form-control border-info'
                                                            name='name'
                                                            id='name'
                                                            defaultValue={unitData?.fromUnit}
                                                            //   ref={(el) => (this.name = el)}
                                                            onChange={(e) => setFromUnit(e.target.value)}
                                                        />
                                                    </div>
                                                    <div class='form-group col-6'>
                                                        <label for='name' className='text-secondary'>
                                                            To Qty
                                                        </label>
                                                        <input
                                                            type='number'
                                                            class='form-control border-info'
                                                            name='name'
                                                            id='name'
                                                            defaultValue={unitData?.toUnit}
                                                            //   ref={(el) => (this.name = el)}
                                                            onChange={(e) => setToUnit(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class='form-group'>
                                                <label for='name' className='text-secondary'>
                                                    Description
                                                </label>
                                                <textarea
                                                    className='form-control'
                                                    id='desc'
                                                    value={description}
                                                    //   ref={(el) => (this.description = el)}
                                                    onChange={(e) => setDescription(e.target.value)}
                                                ></textarea>
                                            </div>
                                            <button
                                                className='btn btn-primary rounded text-center fw-5'
                                                id='submit'
                                                onClick={UnitUpdate}
                                            >
                                                Update
                                            </button>
                                        </div>
                                    </div>
                                ) : (
                                    <div className='col-md-3'>
                                        <div className='card px-3 py-3'>
                                            <h5 className='card-header mb-4 fw-5 text-secondary'>
                                                Create UnitConvention
                                            </h5>
                                            <div class='form-group'>
                                                <label for='code' className='text-secondary'>
                                                    Products
                                                </label>
                                                <select
                                                    class='custom-select border-info'
                                                    name='account_type_id'
                                                    id='cat'
                                                    onChange={(e) => handleItems(e.target.value)}
                                                >
                                                    <option hidden>Choose</option>
                                                    {medicineLists[0] && medicineLists.map((option) => (
                                                        <option value={option._id}>{option.name}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div class='form-group'>
                                                <label for='code' className='text-secondary'>
                                                    Items
                                                </label>
                                                <select
                                                    class='custom-select border-info'
                                                    name='account_type_id'
                                                    id='cat'
                                                    onChange={(e) => handleUnit(e.target.value)}
                                                >
                                                    <option hidden>Choose</option>
                                                    {itemLists[0] && itemLists.map((option) => (
                                                        <option value={option._id}>{option.medicineItemName}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className='border border-black p-2 rounded-lg'>
                                                <div className='py-2'>
                                                    <span className='text-lg font-weight-bold'>Unit Convention</span>
                                                </div>
                                                <div className='row '>
                                                    <div class='form-group col-6'>
                                                        <label for='name' className='text-secondary'>
                                                            From Unit Name
                                                        </label>
                                                        <select
                                                            class='custom-select border-info'
                                                            name='account_type_id'
                                                            id='cat'
                                                            onChange={(e) => setFromUnitName(e.target.value)}
                                                        >
                                                            <option hidden>Choose</option>
                                                            {unitList?.map((option) => (
                                                                <option value={option._id}>{option.unitName}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div class='form-group col-6'>
                                                        <label for='name' className='text-secondary'>
                                                            To Unit Name
                                                        </label>
                                                        <select
                                                            class='custom-select border-info'
                                                            name='account_type_id'
                                                            id='cat'
                                                            onChange={(e) => setToUnitName(e.target.value)}
                                                        >
                                                            <option hidden>Choose</option>
                                                            {unitList?.map((option) => (
                                                                <option value={option._id}>{option.unitName}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div class='form-group col-6'>
                                                        <label for='name' className='text-secondary'>
                                                            From Qty
                                                        </label>
                                                        <input
                                                            type='number'
                                                            class='form-control border-info'
                                                            name='name'
                                                            id='name'
                                                            defaultValue={1}
                                                            //   ref={(el) => (this.name = el)}
                                                            onChange={(e) => setFromUnit(e.target.value || 1)}
                                                        />
                                                    </div>
                                                    <div class='form-group col-6'>
                                                        <label for='name' className='text-secondary'>
                                                            To Qty
                                                        </label>
                                                        <input
                                                            type='number'
                                                            class='form-control border-info'
                                                            name='name'
                                                            id='name'
                                                            //   ref={(el) => (this.name = el)}
                                                            onChange={(e) => setToUnit(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>


                                            <div class='form-group py-2'>
                                                <label for='name' className='text-secondary'>
                                                    Description
                                                </label>
                                                <textarea
                                                    className='form-control'
                                                    id='desc'
                                                    //   ref={(el) => (this.description = el)}
                                                    onChange={(e) => setDescription(e.target.value)}
                                                ></textarea>
                                            </div>
                                            <button
                                                className='btn btn-primary rounded text-center fw-5'
                                                id='submit'
                                                onClick={UnitCreate}
                                            >
                                                Save
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        {/*<!-- /.container-fluid --> */}
                    </section>
                </div>
            </div>
            <SimpleExcelImportDialog
                open={openImport}
                setOpen={setOpenImport}
                type='Unit Convention'
                close={() => setOpenImport(false)}
                Url={"category-excel-import"}
            />
            {/* <!-- /.content-wrapper --> */}
            <footer className='main-footer mt-5'>
                <strong>
                    Copyright &copy; 2017-2020{" "}
                    <a href='http://www.kwintechnologies.com'>K-win Technology</a>.
                </strong>
                All rights reserved.
            </footer>

            {/* <!-- Control Sidebar --> */}
            {/* <aside classNameName="control-sidebar control-sidebar-dark">
       
      </aside> */}
            {/* <!-- /.control-sidebar --> */}

            {/* <!-- ./wrapper --> */}
        </div>
    );
}
export default UnitConvention;
